import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DataTransformService } from '../../shared-services/data-transform/data-transform.service';
import { default as jsonData } from './client-configuration.json';
import { CommonUtilty, AppMetadataHandler, InteractService, LookupDataService } from 'app'
import { clientUtil } from 'app/BaseFramework/core/utilities/clientUtil';
import { claimClientUtil } from 'app/BaseFramework/core/utilities/claimClientUtil';
import { numberUtil } from 'app/BaseFramework/core/utilities/numberUtil';
import { Constants } from 'app/constants';
import { PolicyService } from 'app/FunctionalModules';

@Component({
  selector: "app-client-list",
  templateUrl: "./client-list.component.html",
  styleUrls: ['./client-list.component.scss'],
})
export class ClientListComponent implements OnInit {
  constructor(
    private interactService: InteractService,
    private commonUtilty: CommonUtilty,
    public appMetadataHandler: AppMetadataHandler,
    public dataTransformService: DataTransformService,
    public clientUtil: clientUtil,
    public claimClientUtil: claimClientUtil,
    public numberUtil: numberUtil,
    private ref: ChangeDetectorRef,
    public policyService: PolicyService,
    public lookupDataService: LookupDataService
  ) {
    this.claimClientConfig = jsonData.ClaimClientTableColumnConfig,
      this.Constants = Constants
  }
  Constants: any
  claimClientConfig: any = {};
  paymentDO = new Map();
  clientRoleList: any = [];
  policyNums: Set<any> = new Set();
  refreshClientOnPolicyAddition$: any;
  addClientData$: any;
  selectedClientGuid: any;
  selectedClientData: any;
  clientZeroState
  profilePanelOpen: boolean = false;
  refreshTable: boolean = true;
  newClientDOMap = new Map();
  newRolePolicyClientMap = new Map();
  claimantClientMap = new Map();;
  relationCdLookup: any = [];


  // All Inputs and Outputs
  @Input() capturedRole: any
  allowedRoleTypes = {
    NOMINEE: 'Nominee',
    OWNER: 'Policy Holder',
    PAYER: 'Payer',
    INSURED: 'Additional Insured',
    PRIMARYINSURED: 'Primary Insured'
  }
  @Input() set clientMaps(value) {
    if (value) {
      this.newClientDOMap = value.clientDOHM;
      this.newRolePolicyClientMap = value.claimClientRoles;
      this.refreshClientRoleList(this.capturedRole);
    }
  }
  @Input() IO: any = {}
  @Input() businessType: any
  @Output() componentOutput = new EventEmitter<any>();
  @Output() emittedClient = new EventEmitter<any>();
  @Output() openSearchModal = new EventEmitter<any>();
  @Output() primaryInsuredChange = new EventEmitter<Map<string, Map<string, any>>>();
  @Output() payerDataChanged = new EventEmitter<Map<string, Map<string, any>>>();
  // On component Initialization
  ngOnInit(): void {
    this.clientZeroState = {
      title: `No ${this.capturedRole} selected`,
      message: `No ${this.capturedRole} was found for this case.`,
      icon: null
    }
    this.subscribetoAddClientData()
    this.populateInsuredLookupFromRoleMap();
    this.getFilteredLookupdata()

  }

  subscribetoAddClientData() {
    this.interactService.addClientData$.subscribe(res => {
      if (res !== null) {
        console.log(res)
        this.processNewOrExistingClient(res)
      }
    })

  }

  /**
 * Subscribes to `addClientData$` to either add a new client or update an existing one based on the emitted data.
 * - If `mode` is true, it syncs an existing client record across relevant maps.(**NOTE** : mode flag will be true if user modifies/updates existing client details)
 * - Otherwise, adds a new client entry based on role.
 * - Refreshes the client-role list and triggers change detection.
 */
  subscription$
  processNewOrExistingClient(res) {
    if (this.subscription$) {
      this.subscription$.unsubscribe();
    }
    const { role, ...guidObject } = res;
    const guid = Object.keys(guidObject)[0];
    const clientDO = guidObject[guid].clientDO;
    if (res.mode)
      this.claimClientUtil.syncClientRecord(guid, clientDO, this.newClientDOMap, this.claimantClientMap, this.newRolePolicyClientMap);
    else
      this.addClientBasedOnRole(clientDO, res.role);
    this.refreshClientRoleList(this.capturedRole, res.mode)
    this.populateInsuredLookupFromRoleMap()
    this.ref.detectChanges();
  }

  /**
 * Adds or removes a client as a payee based on the `event` flag.
 * 
 * - If `event` is `true`, the client is marked as a payee and associated payment details are initialized.
 * - If `event` is `false`, the client is removed from the payee list and payment entry is deleted.
 * 
 * The method also updates the nominee payee flag and recalculates split percentage accordingly.
 * 
 * @param {string} clientRefGuid - Unique identifier for the client.
 * @param {string} rolecd - Role code of the client (e.g., NOMINEE, PRIMARYINSURED).
 * @param {boolean} event - Flag indicating add (`true`) or remove (`false`) operation.
 */


  setOrUpdatePrimaryInsured(clientRefGuid, policyNum, rolecd, event) {
    let clientDO = null;
    if (event) {
      clientDO = this.newClientDOMap.get(clientRefGuid);
      this.addClientBasedOnRole(clientDO, rolecd);
    }
    else
      this.claimClientUtil.removeClientFromMap(rolecd, policyNum, clientRefGuid, this.newRolePolicyClientMap);
    this.claimClientUtil.setisPrimaryInsured(clientRefGuid, policyNum, this.newRolePolicyClientMap, event);
    const clientData = this.newClientDOMap.get(clientRefGuid);
    if (clientData)
      clientData['isPrimaryInsured'] = event;
    for (const role of this.newRolePolicyClientMap.keys()) {
      this.refreshClientRoleList(role);
    }
    this.interactService.sendUpdatedData('PRIMARYINSURED')
    this.populateInsuredLookupFromRoleMap()
  }

  setOrUpdatePayer(clientRefGuid, policyNum, rolecd, event) {
    let clientDO = null;
    if (event) {
      clientDO = this.newClientDOMap.get(clientRefGuid);
      this.addClientBasedOnRole(clientDO, rolecd);
      this.claimClientUtil.initializePaymentDO(clientRefGuid, policyNum, this.paymentDO);
    } else this.claimClientUtil.removeClientFromMap(rolecd, policyNum, clientRefGuid, this.newRolePolicyClientMap);
    this.claimClientUtil.setPayer(clientRefGuid, policyNum, this.newRolePolicyClientMap, event);
    const clientData = this.newClientDOMap.get(clientRefGuid);
    if (clientData)
      clientData['isPayer'] = event;
    this.interactService.sendUpdatedData('PAYER')
  }

  /**
 * Triggers edit mode for the selected client and emits the client data to open the search modal.
 * 
 * - Searches the clientRoleList for the client using the `clientRefGuid`.
 * - If found, sets the `editMode` flag to `true` on the client data.
 * - Emits the client data to open the client search/edit modal.
 * 
 * @param {any} selectedClientDO - The client object selected for editing.
 */
  editClient(selectedClientDO) {
    if (this.clientRoleList && Array.isArray(this.clientRoleList)) {
      let fetchedClientDO = this.clientRoleList.find(item => item.clientRefGuid == selectedClientDO.clientRefGuid);
      if (fetchedClientDO) {
        let clientData = fetchedClientDO.clientDO ? fetchedClientDO.clientDO : fetchedClientDO;
        clientData.editMode = true;
        this.openSearchModal.emit(clientData);
      }
    }
  }

  /**
 * Confirms removal of a specific client reference GUID.
 * After successful removal, cleans up any unreferenced clients and refreshes the role list.
 *
 * @param {string} clientRefGuid - The client reference GUID to be removed.
 * @param {string} policyNum - The policy number under which the client exists.
 */
  confirmRemoveClient(clientRefGuid, policyNum) {
    if (clientRefGuid) {
      this.claimClientUtil.removeSpecificClient(clientRefGuid, this.capturedRole, this.newRolePolicyClientMap);
      if (this.capturedRole === Constants.ROLES.NOMINEE) //remove directly from first method call
        this.claimClientUtil.removeSpecificClient(clientRefGuid, Constants.ROLES.PAYEE, this.newRolePolicyClientMap);
      const remainingClientGuids = this.claimClientUtil.collectRemainingClientGuids(this.newRolePolicyClientMap);
      this.claimClientUtil.cleanUnreferencedClients(this.newClientDOMap, [clientRefGuid], remainingClientGuids);
      if (this.capturedRole === Constants.ROLES.NOMINEE)
        this.claimClientUtil.calculateAndSetSplitPer(clientRefGuid, this.newRolePolicyClientMap, policyNum, true, this.paymentDO);
      this.refreshClientRoleList(this.capturedRole);
    }
  }

  EmitOpenSearchModal() {
    this.openSearchModal.emit(false);
    this.dataTransformService.modalFooterOk = true;
  }

  /**
   * Opens the client profile side panel with the selected client’s data.
   * 
   * @param {boolean} status - Flag to open or close the profile panel.
   * @param {any} clientData - Client data used to populate the profile.
   */
  openClientProfile(status, clientData) {
    this.profilePanelOpen = !!status
    if (clientData) this.selectedClientData = clientData.clientDO
  }

  /**
   * Refreshes the client list (clientRoleList) based on the selected roleCd.
   * - Retrieves clients from role-based nested map (newRolePolicyClientMap).
   * - The retrieved clients are flattened and mapped with detailed information.
   * - Triggers table refresh in the UI.
   * 
   * @param {string} roleCd - The role code (e.g., PRIMARYINSURED, NOMINEE, etc.)
   */
  refreshClientRoleList(roleCd, editMode = false) {
    let clientList = [];
    const rolePolicyMap = this.newRolePolicyClientMap.get(roleCd);
    if (rolePolicyMap) {
      clientList = this.claimClientUtil.newFlattenClientDetails(rolePolicyMap, roleCd);
      this.clientRoleList = this.claimClientUtil.clientInformationMapping(clientList);
      console.log("clientList", this.clientRoleList)
      this.refreshTable = false;
      setTimeout(() => {
        this.refreshTable = true;
      }, 20);
    }
  }

  /**
   * Updates the nominee/client split percentage in the clientDO.
   * @param {any} data - Object containing split percentage and client identifiers.
  */
  handleFinalSplitUpdate(data) {
    if (data)
      data.clientDO.splitPercentage = data.splitPercentage;
  }

  /**
   * Adds a client based on their role.
   * @param {any} clientDO - Client data object.
   * @param {string} roleCd - Role code of the client.
   */
  addClientBasedOnRole(clientDO, roleCd) {
    this.claimClientUtil.addClientForPolicyRole(clientDO, roleCd, this.newRolePolicyClientMap, this.newClientDOMap);
  }

    /**
   * Populates the insured lookup list for Nominee selection.
   * - Filters only PRIMARYINSURED and INSURED roles.
   * - Extracts clients from newRolePolicyClientMap for these roles.
   * - Converts client objects to displayable lookup entries using full name.
   * - Stores the resulting list in insuredLookupForNominee.insuredCd.
   */
  insuredLookupForNominee: any = { insuredCd: [] };
  populateInsuredLookupFromRoleMap() {
    const insuredRoles = [Constants.ROLES.PRIMARYINSURED, Constants.ROLES.INSURED];
    this.insuredLookupForNominee.insuredCd = [];

    for (const role of insuredRoles) {
      const roleMap = this.newRolePolicyClientMap.get(role);
      if (roleMap && this.isMapIterable(roleMap)) {
        roleMap.forEach((client) => {
          const fullName = this.commonUtilty.getFullNameFromClient(client)
          this.insuredLookupForNominee.insuredCd.push({
            lookupKey: client.guid,
            lookupCd: "insuredCd",
            lookupValue: fullName,
            sortOrder: null,
            criteriaLookupKey: null
          });
        });
      }
    }
  }

  isMapIterable(map: any): boolean {
    return map instanceof Map && map.size > 0;
  }

    /**
   * Sets the insured client for whom the selected client is a nominee.
   * - Updates the nomineeForInsured field on the nominee's clientDO.
   * - This links the nominee to a specific insured client (e.g., PRIMARYINSURED or INSURED).
   *
   * @param {any} data - Contains nominee clientDO.
   */
  onSelectNomineeFor(data: any): void {
    if (data && data.clientDO) {
      data.clientDO.nomineeForInsured = data.nomineeForInsured;
    }
  }

  /**
 * Fetches and assigns lookup data related to relation codes for client relationships.
 */
  getFilteredLookupdata() {
    this.lookupDataService.getLookup('relationCd').subscribe(lookupData => {
      this.relationCdLookup = this.commonUtilty.deepCopy(lookupData);
    })
  }
  
  /**
 * Updates the `relationship` field of the clientDO when the relationship to the insured changes.
 * @param {any} data - Object containing clientDO and updated relationship code.
 */
  onRelationChange(data: any) {
    if (data && data.clientDO) data.clientDO.relationship = data.relationship; 
  }
}